import { ContactCard } from 'src/types';
import CustomPageBlock, { PageBlockProps } from './page-block';
import css from './custom-page.module.scss';
import { CONTACTS } from 'src/constants/routes';
import { ContactView } from '../contacts/contactCard';

export default function CustomPageContacts({ items, title, description, type }: Readonly<PageBlockProps<ContactCard>>) {
  return (
    <CustomPageBlock title={title} description={description} type={type} path={CONTACTS.path}>
      <div className={css.card}>
        <div className={css.contactWrapper}>{items?.map((card) => <ContactView card={card} key={card.id} />)}</div>
      </div>
    </CustomPageBlock>
  );
}
